export default __webpack_public_path__ + "static/746-82aef68a12301ca1c0e2c50f6df52c0b.gif";